import axios from "axios";
import authHeader from '../../../authheader'

const LSINOTIFICATIONPREFERENCEURL = process.env.REACT_APP_APIURL + "/api/NotificationPreferences";


const getPrivacyData = (entityId) => {
    return axios.get(`${LSINOTIFICATIONPREFERENCEURL}/journalandprivacy`, { headers: authHeader(), params: { entityId } });
}
const postPrivacyData = (data) => {
    return axios.post(`${LSINOTIFICATIONPREFERENCEURL}/journalandprivacy`, data, { headers: authHeader() });
}
export default {
    getPrivacyData,
    postPrivacyData
}